<template>
    <v-container fluid>
        <v-snackbar
            app
            top
            v-model="snackbar">
            {{ text }}
            <template v-slot:action="{ attrs }">
                <v-btn
                color="blue"
                text
                v-bind="attrs"
                @click="snackbar = false">
                {{$t('message.close')}}
                </v-btn>
            </template>
        </v-snackbar>
        <v-row>
            <v-col cols="2"></v-col>
            <v-col cols="8">
                <p class="text-h4">{{$t('message.profile')}}</p>
                <v-form ref="form" v-model="valid" lazy-validation >
                    <v-text-field v-model="user.name" :rules="nameRules" :label="$t('message.name')" required></v-text-field>
                    <v-text-field v-model="user.username" :label="$t('message.username')" required disabled></v-text-field>
                    <v-text-field v-model="user.email" :rules="emailRules" :label="$t('message.email')" required></v-text-field>   
                    <v-text-field
                        v-model="password"
                        :type="'password'"
                        :label="$t('message.change_password_hint')"
                        :hint="$t('message.change_password')"
                    ></v-text-field>         
                    <v-text-field
                        v-model="newPassword"
                        :rules=[checkPassword]
                        :type="'password'"
                        :label="$t('message.change_password_repeat')"
                    ></v-text-field>          
                </v-form>
                <v-btn class="mt-10" color="primary" @click=update :disabled="checkIfModifiedForm">{{$t('message.update_changes')}}</v-btn>
            </v-col>
            <v-col cols="2"></v-col>
        </v-row>
  </v-container>
</template>

<script>
    import i18n from '../i18n/messages';
    import Api from '../services/Api';
    import Parser from '../utils/parser';
    import User from '../entities/User';
    export default {
        data: () => ({
            user: new User(0,'','','',''),
            cachedUser: new User(0, '', '', ''),
            nameRules: [
                v => !!v || i18n.t('message.required_name'),
                v => (v && v.length <= 45) || i18n.t('message.required_name_invalid'),
            ],
            emailRules: [
                v => !!v || i18n.t('message.required_email'),
                v => /.+@.+\..+/.test(v) || i18n.t('message.required_email_invalid'),
            ],
            password:'',           
            newPassword:'',
            snackbar: false,
            text:'',
            valid: [],

        }),
        methods: { 
            update(){                                         
                if(this.valid){
                    var pwd = (this.password != '' ? this.password : '')
                    Api.updateInfo(this.user.name,this.user.email,pwd,this.$store.state.auth.token)
                        .then(()=>{
                            this.snackbar=true;
                            this.cachedUser.name = this.user.name; 
                            this.cachedUser.email = this.user.email;
                            this.password = '';
                            this.newPassword = '';
                            this.text = i18n.t('message.update_success');
                        })
                        .catch(()=>{
                            this.text = i18n.t('message.update_fail');

                        });
                }
            },
            checkPassword(){
                return (this.password == this.newPassword || i18n.t('message.required_password_invalid'));
            },
            
        },
        computed:{
            checkIfModifiedForm(){                
                if( this.user.name != this.cachedUser.name || 
                    this.user.email != this.cachedUser.email ||
                    this.password != ''){      
                        return false;
                    }
                return true;
            }
        },
        mounted(){
            Api.getMyInfo(this.$store.state.auth.token)
                .then(response=>{
                    this.user = Parser.getMyInfoToUser(response.data);
                    this.cachedUser = Parser.getMyInfoToUser(response.data);
                })
                .catch(err=>{
                    console.log(err);
                })
        }

    }
</script>